/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
} from 'data-fetching-client';
import * as References from './AutomationEmbeddedServiceV2';
import * as Queries from './AutomationEmbeddedServiceV2.dfc.new';
import type { AdditionalContextArgs } from './AutomationEmbeddedServiceV2.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseFetchAllowedActionTypesQueryReturn<T extends boolean> = Omit<
  QueryResult<Record<'result', References.FetchAllowedActionTypesResponseType>>,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'fetchAllowedActionTypes',
            References.FetchAllowedActionTypesResponseType
          >
        : References.FetchAllowedActionTypesResponseType)
    | undefined;
};

export function useFetchAllowedActionTypesQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.FetchAllowedActionTypesResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchAllowedActionTypesQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.FETCH_ALLOWED_ACTION_TYPES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            fetchAllowedActionTypes: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseFetchAllowedActionTypesQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseFetchAllowedActionTypesQueryReturn<T>;
}

type UseFetchAllowedActionTypesLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.FetchAllowedActionTypesResponseType>,
    {},
    T extends true
      ? Record<
          'fetchAllowedActionTypes',
          References.FetchAllowedActionTypesResponseType
        >
      : References.FetchAllowedActionTypesResponseType
  >;

export function useFetchAllowedActionTypesLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.FetchAllowedActionTypesResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchAllowedActionTypesLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.FETCH_ALLOWED_ACTION_TYPES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            fetchAllowedActionTypes: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseFetchAllowedActionTypesLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseFetchAllowedActionTypesLazyQueryReturn<T>;
}

type UseFetchAllowedActionTypesSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.FetchAllowedActionTypesResponseType>
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'fetchAllowedActionTypes',
        References.FetchAllowedActionTypesResponseType
      >
    : References.FetchAllowedActionTypesResponseType;
};

export function useFetchAllowedActionTypesSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.FetchAllowedActionTypesResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchAllowedActionTypesSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.FETCH_ALLOWED_ACTION_TYPES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            fetchAllowedActionTypes: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseFetchAllowedActionTypesSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseFetchAllowedActionTypesSuspenseQueryReturn<T>;
}

type UseFetchAllowedTriggersQueryReturn<T extends boolean> = Omit<
  QueryResult<Record<'result', References.FetchAllowedTriggersResponseType>>,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'fetchAllowedTriggers',
            References.FetchAllowedTriggersResponseType
          >
        : References.FetchAllowedTriggersResponseType)
    | undefined;
};

export function useFetchAllowedTriggersQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.FetchAllowedTriggersResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchAllowedTriggersQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.FETCH_ALLOWED_TRIGGERS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            fetchAllowedTriggers: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseFetchAllowedTriggersQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseFetchAllowedTriggersQueryReturn<T>;
}

type UseFetchAllowedTriggersLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.FetchAllowedTriggersResponseType>,
    {},
    T extends true
      ? Record<
          'fetchAllowedTriggers',
          References.FetchAllowedTriggersResponseType
        >
      : References.FetchAllowedTriggersResponseType
  >;

export function useFetchAllowedTriggersLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.FetchAllowedTriggersResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchAllowedTriggersLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.FETCH_ALLOWED_TRIGGERS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            fetchAllowedTriggers: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseFetchAllowedTriggersLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseFetchAllowedTriggersLazyQueryReturn<T>;
}

type UseFetchAllowedTriggersSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.FetchAllowedTriggersResponseType>
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'fetchAllowedTriggers',
        References.FetchAllowedTriggersResponseType
      >
    : References.FetchAllowedTriggersResponseType;
};

export function useFetchAllowedTriggersSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.FetchAllowedTriggersResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchAllowedTriggersSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.FETCH_ALLOWED_TRIGGERS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            fetchAllowedTriggers: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseFetchAllowedTriggersSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseFetchAllowedTriggersSuspenseQueryReturn<T>;
}

type UseFetchPermissionsQueryReturn<T extends boolean> = Omit<
  QueryResult<Record<'result', References.FetchPermissionsResponseType>>,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'fetchPermissions', References.FetchPermissionsResponseType>
        : References.FetchPermissionsResponseType)
    | undefined;
};

export function useFetchPermissionsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.FetchPermissionsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchPermissionsQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.FETCH_PERMISSIONS_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            fetchPermissions: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseFetchPermissionsQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseFetchPermissionsQueryReturn<T>;
}

type UseFetchPermissionsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.FetchPermissionsResponseType>,
    {},
    T extends true
      ? Record<'fetchPermissions', References.FetchPermissionsResponseType>
      : References.FetchPermissionsResponseType
  >;

export function useFetchPermissionsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.FetchPermissionsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchPermissionsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.FETCH_PERMISSIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            fetchPermissions: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseFetchPermissionsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseFetchPermissionsLazyQueryReturn<T>;
}

type UseFetchPermissionsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.FetchPermissionsResponseType>
  >,
  'data'
> & {
  data: T extends true
    ? Record<'fetchPermissions', References.FetchPermissionsResponseType>
    : References.FetchPermissionsResponseType;
};

export function useFetchPermissionsSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.FetchPermissionsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchPermissionsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.FETCH_PERMISSIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            fetchPermissions: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseFetchPermissionsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseFetchPermissionsSuspenseQueryReturn<T>;
}

type UseFetchEmbeddedSummaryQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.FetchEmbeddedSummaryResponseType>,
    References.FetchEmbeddedSummaryRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'fetchEmbeddedSummary',
            References.FetchEmbeddedSummaryResponseType
          >
        : References.FetchEmbeddedSummaryResponseType)
    | undefined;
};

export function useFetchEmbeddedSummaryQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.FetchEmbeddedSummaryResponseType>,
    References.FetchEmbeddedSummaryRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchEmbeddedSummaryQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.FETCH_EMBEDDED_SUMMARY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            fetchEmbeddedSummary: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseFetchEmbeddedSummaryQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseFetchEmbeddedSummaryQueryReturn<T>;
}

type UseFetchEmbeddedSummaryLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.FetchEmbeddedSummaryResponseType>,
    References.FetchEmbeddedSummaryRequestType,
    T extends true
      ? Record<
          'fetchEmbeddedSummary',
          References.FetchEmbeddedSummaryResponseType
        >
      : References.FetchEmbeddedSummaryResponseType
  >;

export function useFetchEmbeddedSummaryLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.FetchEmbeddedSummaryResponseType>,
    References.FetchEmbeddedSummaryRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchEmbeddedSummaryLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.FETCH_EMBEDDED_SUMMARY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            fetchEmbeddedSummary: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseFetchEmbeddedSummaryLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseFetchEmbeddedSummaryLazyQueryReturn<T>;
}

type UseFetchEmbeddedSummarySuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.FetchEmbeddedSummaryResponseType>,
    References.FetchEmbeddedSummaryRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'fetchEmbeddedSummary',
        References.FetchEmbeddedSummaryResponseType
      >
    : References.FetchEmbeddedSummaryResponseType;
};

export function useFetchEmbeddedSummarySuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.FetchEmbeddedSummaryResponseType>,
    References.FetchEmbeddedSummaryRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchEmbeddedSummarySuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.FETCH_EMBEDDED_SUMMARY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            fetchEmbeddedSummary: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseFetchEmbeddedSummarySuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseFetchEmbeddedSummarySuspenseQueryReturn<T>;
}

type UseFetchRelatedAutomationsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.FetchRelatedAutomationsResponseType>,
    References.FetchRelatedAutomationsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'fetchRelatedAutomations',
            References.FetchRelatedAutomationsResponseType
          >
        : References.FetchRelatedAutomationsResponseType)
    | undefined;
};

export function useFetchRelatedAutomationsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.FetchRelatedAutomationsResponseType>,
    References.FetchRelatedAutomationsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchRelatedAutomationsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.FETCH_RELATED_AUTOMATIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            fetchRelatedAutomations: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseFetchRelatedAutomationsQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseFetchRelatedAutomationsQueryReturn<T>;
}

type UseFetchRelatedAutomationsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.FetchRelatedAutomationsResponseType>,
    References.FetchRelatedAutomationsRequestType,
    T extends true
      ? Record<
          'fetchRelatedAutomations',
          References.FetchRelatedAutomationsResponseType
        >
      : References.FetchRelatedAutomationsResponseType
  >;

export function useFetchRelatedAutomationsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.FetchRelatedAutomationsResponseType>,
    References.FetchRelatedAutomationsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchRelatedAutomationsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.FETCH_RELATED_AUTOMATIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            fetchRelatedAutomations: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseFetchRelatedAutomationsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseFetchRelatedAutomationsLazyQueryReturn<T>;
}

type UseFetchRelatedAutomationsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.FetchRelatedAutomationsResponseType>,
    References.FetchRelatedAutomationsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'fetchRelatedAutomations',
        References.FetchRelatedAutomationsResponseType
      >
    : References.FetchRelatedAutomationsResponseType;
};

export function useFetchRelatedAutomationsSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.FetchRelatedAutomationsResponseType>,
    References.FetchRelatedAutomationsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchRelatedAutomationsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.FETCH_RELATED_AUTOMATIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            fetchRelatedAutomations: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseFetchRelatedAutomationsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseFetchRelatedAutomationsSuspenseQueryReturn<T>;
}

type UseFetchAllAutomationsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.FetchAllAutomationsResponseType>,
    References.FetchAllAutomationsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'fetchAllAutomations',
            References.FetchAllAutomationsResponseType
          >
        : References.FetchAllAutomationsResponseType)
    | undefined;
};

export function useFetchAllAutomationsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.FetchAllAutomationsResponseType>,
    References.FetchAllAutomationsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchAllAutomationsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.FETCH_ALL_AUTOMATIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            fetchAllAutomations: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseFetchAllAutomationsQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseFetchAllAutomationsQueryReturn<T>;
}

type UseFetchAllAutomationsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.FetchAllAutomationsResponseType>,
    References.FetchAllAutomationsRequestType,
    T extends true
      ? Record<
          'fetchAllAutomations',
          References.FetchAllAutomationsResponseType
        >
      : References.FetchAllAutomationsResponseType
  >;

export function useFetchAllAutomationsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.FetchAllAutomationsResponseType>,
    References.FetchAllAutomationsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchAllAutomationsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.FETCH_ALL_AUTOMATIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            fetchAllAutomations: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseFetchAllAutomationsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseFetchAllAutomationsLazyQueryReturn<T>;
}

type UseFetchAllAutomationsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.FetchAllAutomationsResponseType>,
    References.FetchAllAutomationsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'fetchAllAutomations', References.FetchAllAutomationsResponseType>
    : References.FetchAllAutomationsResponseType;
};

export function useFetchAllAutomationsSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.FetchAllAutomationsResponseType>,
    References.FetchAllAutomationsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchAllAutomationsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.FETCH_ALL_AUTOMATIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            fetchAllAutomations: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseFetchAllAutomationsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseFetchAllAutomationsSuspenseQueryReturn<T>;
}

type UseSearchRelatedAutomationsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.SearchRelatedAutomationsResponseType>,
    References.SearchRelatedAutomationsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'searchRelatedAutomations',
            References.SearchRelatedAutomationsResponseType
          >
        : References.SearchRelatedAutomationsResponseType)
    | undefined;
};

export function useSearchRelatedAutomationsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.SearchRelatedAutomationsResponseType>,
    References.SearchRelatedAutomationsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSearchRelatedAutomationsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.SEARCH_RELATED_AUTOMATIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            searchRelatedAutomations: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseSearchRelatedAutomationsQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseSearchRelatedAutomationsQueryReturn<T>;
}

type UseSearchRelatedAutomationsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.SearchRelatedAutomationsResponseType>,
    References.SearchRelatedAutomationsRequestType,
    T extends true
      ? Record<
          'searchRelatedAutomations',
          References.SearchRelatedAutomationsResponseType
        >
      : References.SearchRelatedAutomationsResponseType
  >;

export function useSearchRelatedAutomationsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.SearchRelatedAutomationsResponseType>,
    References.SearchRelatedAutomationsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSearchRelatedAutomationsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.SEARCH_RELATED_AUTOMATIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            searchRelatedAutomations: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseSearchRelatedAutomationsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseSearchRelatedAutomationsLazyQueryReturn<T>;
}

type UseSearchRelatedAutomationsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.SearchRelatedAutomationsResponseType>,
    References.SearchRelatedAutomationsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'searchRelatedAutomations',
        References.SearchRelatedAutomationsResponseType
      >
    : References.SearchRelatedAutomationsResponseType;
};

export function useSearchRelatedAutomationsSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.SearchRelatedAutomationsResponseType>,
    References.SearchRelatedAutomationsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSearchRelatedAutomationsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.SEARCH_RELATED_AUTOMATIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            searchRelatedAutomations: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseSearchRelatedAutomationsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseSearchRelatedAutomationsSuspenseQueryReturn<T>;
}

type UseFetchTemplatesQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.FetchTemplatesResponseType>,
    References.FetchTemplatesRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'fetchTemplates', References.FetchTemplatesResponseType>
        : References.FetchTemplatesResponseType)
    | undefined;
};

export function useFetchTemplatesQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.FetchTemplatesResponseType>,
    References.FetchTemplatesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchTemplatesQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.FETCH_TEMPLATES_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            fetchTemplates: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseFetchTemplatesQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseFetchTemplatesQueryReturn<T>;
}

type UseFetchTemplatesLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.FetchTemplatesResponseType>,
    References.FetchTemplatesRequestType,
    T extends true
      ? Record<'fetchTemplates', References.FetchTemplatesResponseType>
      : References.FetchTemplatesResponseType
  >;

export function useFetchTemplatesLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.FetchTemplatesResponseType>,
    References.FetchTemplatesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchTemplatesLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.FETCH_TEMPLATES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            fetchTemplates: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseFetchTemplatesLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseFetchTemplatesLazyQueryReturn<T>;
}

type UseFetchTemplatesSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.FetchTemplatesResponseType>,
    References.FetchTemplatesRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'fetchTemplates', References.FetchTemplatesResponseType>
    : References.FetchTemplatesResponseType;
};

export function useFetchTemplatesSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.FetchTemplatesResponseType>,
    References.FetchTemplatesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchTemplatesSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.FETCH_TEMPLATES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            fetchTemplates: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseFetchTemplatesSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseFetchTemplatesSuspenseQueryReturn<T>;
}

type UseFetchWorkflowQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.FetchWorkflowResponseType>,
    References.FetchWorkflowRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'fetchWorkflow', References.FetchWorkflowResponseType>
        : References.FetchWorkflowResponseType)
    | undefined;
};

export function useFetchWorkflowQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.FetchWorkflowResponseType>,
    References.FetchWorkflowRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchWorkflowQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.FETCH_WORKFLOW_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            fetchWorkflow: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseFetchWorkflowQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseFetchWorkflowQueryReturn<T>;
}

type UseFetchWorkflowLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.FetchWorkflowResponseType>,
    References.FetchWorkflowRequestType,
    T extends true
      ? Record<'fetchWorkflow', References.FetchWorkflowResponseType>
      : References.FetchWorkflowResponseType
  >;

export function useFetchWorkflowLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.FetchWorkflowResponseType>,
    References.FetchWorkflowRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchWorkflowLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.FETCH_WORKFLOW_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            fetchWorkflow: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseFetchWorkflowLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseFetchWorkflowLazyQueryReturn<T>;
}

type UseFetchWorkflowSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.FetchWorkflowResponseType>,
    References.FetchWorkflowRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'fetchWorkflow', References.FetchWorkflowResponseType>
    : References.FetchWorkflowResponseType;
};

export function useFetchWorkflowSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.FetchWorkflowResponseType>,
    References.FetchWorkflowRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchWorkflowSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.FETCH_WORKFLOW_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            fetchWorkflow: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseFetchWorkflowSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseFetchWorkflowSuspenseQueryReturn<T>;
}

type UseResolveWorkflowLinksQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.ResolveWorkflowLinksResponseType>,
    References.ResolveWorkflowLinksRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'resolveWorkflowLinks',
            References.ResolveWorkflowLinksResponseType
          >
        : References.ResolveWorkflowLinksResponseType)
    | undefined;
};

export function useResolveWorkflowLinksQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.ResolveWorkflowLinksResponseType>,
    References.ResolveWorkflowLinksRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseResolveWorkflowLinksQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.RESOLVE_WORKFLOW_LINKS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            resolveWorkflowLinks: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseResolveWorkflowLinksQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseResolveWorkflowLinksQueryReturn<T>;
}

type UseResolveWorkflowLinksLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.ResolveWorkflowLinksResponseType>,
    References.ResolveWorkflowLinksRequestType,
    T extends true
      ? Record<
          'resolveWorkflowLinks',
          References.ResolveWorkflowLinksResponseType
        >
      : References.ResolveWorkflowLinksResponseType
  >;

export function useResolveWorkflowLinksLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.ResolveWorkflowLinksResponseType>,
    References.ResolveWorkflowLinksRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseResolveWorkflowLinksLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.RESOLVE_WORKFLOW_LINKS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            resolveWorkflowLinks: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseResolveWorkflowLinksLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseResolveWorkflowLinksLazyQueryReturn<T>;
}

type UseResolveWorkflowLinksSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.ResolveWorkflowLinksResponseType>,
    References.ResolveWorkflowLinksRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'resolveWorkflowLinks',
        References.ResolveWorkflowLinksResponseType
      >
    : References.ResolveWorkflowLinksResponseType;
};

export function useResolveWorkflowLinksSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.ResolveWorkflowLinksResponseType>,
    References.ResolveWorkflowLinksRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseResolveWorkflowLinksSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.RESOLVE_WORKFLOW_LINKS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            resolveWorkflowLinks: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseResolveWorkflowLinksSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseResolveWorkflowLinksSuspenseQueryReturn<T>;
}
